module.exports = __webpack_public_path__ + "img/App2.ff3837d5.svg";